import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import './HelpModal.css';

/**
 * Full-view help modal that slides in from the left.
 * Reusable for any screen's user guide / help content.
 * @param {boolean} isOpen - Whether the modal is visible
 * @param {function} onClose - Callback when modal is closed
 * @param {string} title - Modal title (e.g. "Burn Expense Entry - Help")
 * @param {React.ReactNode} children - Help content (sections, paragraphs, lists)
 */
const HelpModal = ({ isOpen, onClose, title = 'Help', children }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') onClose();
  };

  if (!isOpen) return null;

  return (
    <div
      className="help-modal-overlay"
      onClick={handleOverlayClick}
      onKeyDown={handleKeyDown}
      role="dialog"
      aria-modal="true"
      aria-labelledby="help-modal-title"
    >
      <div className="help-modal-panel">
        <div className="help-modal-header">
          <h2 id="help-modal-title" className="help-modal-title">{title}</h2>
          <button
            type="button"
            className="help-modal-close"
            onClick={onClose}
            aria-label="Close help"
          >
            <X size={24} />
          </button>
        </div>
        <div className="help-modal-content">
          {children}
        </div>
      </div>
    </div>
  );
};

export default HelpModal;
